import { render, staticRenderFns } from "./AnswerListItem.vue?vue&type=template&id=440b022a&scoped=true&"
import script from "./AnswerListItem.vue?vue&type=script&lang=js&"
export * from "./AnswerListItem.vue?vue&type=script&lang=js&"
import style0 from "./AnswerListItem.vue?vue&type=style&index=0&id=440b022a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440b022a",
  null
  
)

export default component.exports